// src/pages/JobDetails.jsx
import { useState } from "react";
import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import JobDetailsForm from "../components/JobDetailsForm";

function JobDetails() {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="app">
      {showSidebar && (
        <div className="overlay show" onClick={() => setShowSidebar(false)} />
      )}

      <Sidebar show={showSidebar} closeSidebar={() => setShowSidebar(false)} />

      <div className="main">
        <Topbar toggleSidebar={() => setShowSidebar((p) => !p)} />
        <div className="page">
          <JobDetailsForm />
        </div>
      </div>
    </div>
  );
}

export default JobDetails;